import moment from 'moment';

//toggle function used to toggle extra life functionality
//NOTE: state.date.isExtraLife variable is UNAFFECTED
//NOTE: modify the line with comment "//edit this line (! on this.state.extraLifeValid) when toggling extra life" on dateSelector.js to toggle for testing
//also need to look at "extraLifeExists" state variable in same file and modify extra life dates
export default function toggleExtraLife() {
    // return false;
    //toggles extra life components  IF before /on extra life days.
    // let samepleDay = moment('2019-11-04');       //modify this and if statement for proof of concept
    if (moment().isBefore(moment('2020-11-07'), 'day') || moment().isSame(moment('2020-11-07'), 'day')) {
        return true;
    } else {
        return false;
    }
    // return false;
}